const Failure = () => {
  return <></>;
};

export default Failure;
